let Trix = require("trix");

jQuery(document).ready(function($) {
    Trix.config.lang.captionPlaceholder = "Enter a URL (ie. https://4us.org)";
    Trix.config.attachments.preview.caption = { name: false, size: false };
});
